export const links =  ['home', 'about', 'work', 'skills', 'contact']